import React, 
{ 
    useEffect,
    useState 
} from 'react'

import toast from 'react-hot-toast';
import dayjs from 'dayjs';

import { 
    Delete,
    Edit,
} from '@mui/icons-material';

import { 
    Form,
    Input,
    Col, 
    Row,
    Table,
    Space,
    Button,
    DatePicker,
} from 'antd';

import { usePostRequest } from '../../hooks/usePostRequest'

const BillingCaddies = ({caddiesData, fetchMembersData, isLoading, id}) => {
    // const navigate = useNavigate() 
    const { callPost, loading } = usePostRequest(()=>{
        fetchMembersData();
    });
    const [caddiesInfo, setCaddiesInfo] = useState([])

    const handleDelete = (key) => {
        const newData = [...caddiesInfo];
        newData.splice(key, 1); 
        setCaddiesInfo(() => newData)
    };
      
    const addRow = () => {
        const newData = [...caddiesInfo];
        newData.push({
            cadd_ors: '',
            cadd_dates: undefined,
            cadd_amounts: '',
            isWritable: true,
        });
        setCaddiesInfo(newData);
    };

    const handleTable = (e, index, name, isDate) => {
        if(isDate){
            setCaddiesInfo(prevState => {
                const newState = [...prevState];
                newState[index] = { 
                    ...newState[index],
                    [name]: e
                };
                return newState;
            });
        } else {
            const { value } = e.target

            setCaddiesInfo(prevState => {
            const newState = [...prevState];
            newState[index] = { 
                ...newState[index],
                [name]: value
            };
            return newState;
            });
        }
    }

    const handleRowClick = (row_id) => {
        const newData = caddiesInfo?.map((item, index) => ({
          ...item,
          isWritable: row_id === index ? !item.isWritable : item.isWritable,
        }));
        setCaddiesInfo(newData);
    };

    const defaultColumns = [
        {
          title: 'OR',
          dataIndex: 'cadd_ors',
          align: 'center',
          key: 'cadd_ors',
          render: (_, record, index) => (
            record.isWritable ? (
                
                <Input
                    value={record.cadd_ors}
                    onChange={(e) => handleTable(e, index, "cadd_ors")}
                />
            ) : record.cadd_ors
          ),
        },
        {
          title: 'Date',
          dataIndex: 'cadd_dates',
          align: 'center',
          key: 'cadd_dates',
          render: (_, record, index) => (
            record.isWritable ? (
                <DatePicker        
                    style={{width:'100%'}}
                    value={record.cadd_dates}
                    onChange={(e) => handleTable(e, index, "cadd_dates", true)}
                />
            ) : record.cadd_dates?.format('MMMM D, YYYY')
          ),
        },
        {
          title: 'Amount',
          dataIndex: 'cadd_amounts',
          align: 'center',
          key: 'cadd_amounts',
          render: (_, record, index) => (
            record.isWritable ? (
                <Input
                    value={record.cadd_amounts}
                    onChange={(e) => handleTable(e, index, "cadd_amounts")}
                />
            ) : record.cadd_amounts
          ),
        },
        {
            title: '',
            dataIndex: '',
            align: 'center',
            render: (_, record, index) => (
                <Space>
                    {
                        (record.id) && (
                            <div 
                                onClick={() => handleRowClick(index)}
                                className='cursor'
                            >
                                <Edit/>
                            </div>
                        )
                    }
                    <div 
                        onClick={() => handleDelete(index)}
                        className='cursor'
                    >
                        <Delete  
                            style={{
                                color: 'red',
                            }}
                        />
                    </div>
                </Space>
            ),
            onCell: () => ({
                onClick: (e) => {
                e.stopPropagation();
                },
            }),
        },
    ];

    const handleCreateAdmission = () => {
        try {
            const newValues = {
                member_id: id,
                id: [],
                cadd_ors: [],
                cadd_dates: [],
                cadd_amounts: [],
            }

            caddiesInfo?.forEach(item => {
                newValues.id.push(item.id || "");
                newValues.cadd_ors.push(item.cadd_ors || "");
                newValues.cadd_amounts.push(item.cadd_amounts || "");
                newValues.cadd_dates?.push(item.cadd_dates ? item.cadd_dates.format("YYYY-MM-DD") : "");
            });

            callPost(
                "members/update_caddies", 
                newValues,
                false,
            );
        }catch(errorInfo) {
            toast.error('Validation Failed ', errorInfo);
        };
    };

    const validateArray = (array) => {
        return array.every((item) => {
            return item.cadd_ors !== "" || item.cadd_dates !== undefined || item.cadd_amounts !== "";
        });
    };  

    useEffect(() => {
        if(caddiesData){
            const admission_data = caddiesData?.map((data) => ({
                id: data.id,
                member_id: data.member_id,
                cadd_ors: data.or,
                cadd_dates: data.date ? dayjs(data.date) : undefined,
                cadd_amounts: data.amount,
                added_by: data.added_by,
                added_on: data.added_on,
                updated_by: data.updated_by,
                updated_on: data.updated_on,
                is_deleted: data.is_deleted,
            }))
             
            setCaddiesInfo(admission_data)
        }
    }, [caddiesData])

    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                >
                    <Row>
                        <Col span={24} className='responsive-overflow-y'>
                            <Table
                                bordered
                                dataSource={caddiesInfo}
                                columns={defaultColumns}
                                pagination={false}
                                loading={isLoading}
                                scroll={{ x: 800 }} 
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                        <Col span={24}>
                            <Button 
                                type="primary" 
                                onClick={addRow}
                            >
                                Add Row
                            </Button>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateAdmission}
                                loading={loading}
                                type='primary'
                                disabled={!validateArray(caddiesInfo)}
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export default BillingCaddies
